import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import '@blueprint/frontend-basics/dist/blueprint-basics.es.css'
import 'reflect-metadata'

import BlueprintBasics, {
  createVuetifyInstance,
  createAppRouter,
  createLanguageStore,
  createAppI18n,
  defaultLang,
  useUserStore,
  Routes,
  type LanguageStore,
  type SupportedLang,
} from '@blueprint/frontend-basics'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import routes from './router/index.ts'
import { additionalMessages } from './i18n/i18n.ts'
import { useServiceStore } from './stores/service.store.ts'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(BlueprintBasics)

const supportedLanguages: SupportedLang[] = ['en']
const useLanguageStore = createLanguageStore(supportedLanguages)
const languageStore: LanguageStore = useLanguageStore()
app.provide('languageStore', languageStore)

const i18n = createAppI18n({
  supportedLanguages,
  defaultLanguage: defaultLang,
  additionalMessages,
})

const vuetify = createVuetifyInstance(i18n)
const router = createAppRouter(routes as any, {
  i18n,
  defaultLang,
  languageStore,
})

app.use(router)
app.use(vuetify)
app.use(i18n)

const userStore = useUserStore()
const serviceStore = useServiceStore()
app.provide('serviceStore', serviceStore)
userStore.init(serviceStore, router)

app.mount('#app')

export { Routes }
